<template>
  <div class="login-container">
    <div class="login-card">
      <div class="login-header">
        <img src="@/assets/logo.jpg" alt="Logo" class="logo" />
        <p>Sistema interno</p>
      </div>
      
      <form @submit.prevent="handleLogin" class="login-form">
        <div class="form-group">
          <label for="username">Usuário</label>
          <input 
            type="text" 
            id="username" 
            v-model="username" 
            placeholder="Digite seu usuário"
            required
          />
        </div>
        
        <div class="form-group">
          <label for="password">Senha</label>
          <input 
            type="password" 
            id="password" 
            v-model="password" 
            placeholder="Digite sua senha"
            required
          />
        </div>
        
        <div v-if="error" class="error-message">
          {{ error }}
        </div>
        
        <button 
          type="submit" 
          class="login-button" 
          :disabled="loading"
        >
          <span v-if="loading">Carregando...</span>
          <span v-else>Entrar</span>
        </button>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
      error: null,
      loading: false
    }
  },
  methods: {

    async handleLogin() {
      this.error = null;
      this.loading = true;

      try {
        const formData = new URLSearchParams();
        formData.append('username', this.username);
        formData.append('password', this.password);

        // const response = await fetch('http://localhost:8000/auth/token', { 
        const response = await fetch('https://api.plannedbr.com.br/auth/token', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          },
          body: formData
        });

        if (!response.ok) {
          const errData = await response.json();
          this.error = errData.detail || 'Falha na autenticação';
        } else {
          const data = await response.json();
          localStorage.setItem('token', data.access_token);

          this.$router.push('/dashboard');

          // Refresh page
          window.location.reload();
        }
      } catch (err) {
        this.error = 'Erro ao conectar ao servidor';
        console.error(err);
      } finally {
        this.loading = false;
      }
    }
  },
  created() {
    // Se já estiver autenticado, redireciona para o dashboard
    if (this.$store.getters.isAuthenticated) {
      this.$router.push('/dashboard');
    }
  }
}
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f5f7fa;
}

.login-card {
  width: 100%;
  max-width: 400px;
  padding: 2rem;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.login-header {
  text-align: center;
  margin-bottom: 2rem;
}

.login-header h1 {
  color: #3b82f6;
  margin-bottom: 0.5rem;
}

.login-header p {
  color: #64748b;
}

.logo {
  width: 190px;
  max-width: 60%;
  margin: 0 auto 0.5rem;
  display: block;
}

.login-form {
  display: flex;
  flex-direction: column;
}

.form-group {
  margin-bottom: 1.5rem;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: #334155;
}

.form-group input {
  width: 100%;
  padding: 0.75rem;
  border: 1px solid #cbd5e1;
  border-radius: 4px;
  font-size: 1rem;
}

.form-group input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.2);
}

.error-message {
  color: #ef4444;
  margin-bottom: 1rem;
  font-size: 0.875rem;
}

.login-button {
  padding: 0.75rem 1rem;
  background-color: #2c2d2e;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.login-button:hover {
  background-color: #2563eb;
}

.login-button:disabled {
  background-color: #93c5fd;
  cursor: not-allowed;
}
</style>
